import { createContext, useContext, useEffect, useState } from "react";

const DisclaimerContext = createContext();

export const useDisclaimer = () => {
    const context = useContext(DisclaimerContext);
    if (!context) {
        throw new Error("useDisclaimer must be used within a DisclaimerProvider");
    }
    return context;
};

export const DisclaimerProvider = ({ children }) => {
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    // Check if disclaimer was already accepted on mount
    useEffect(() => {
        const disclaimerAccepted = localStorage.getItem("disclaimerAccepted");
        if (disclaimerAccepted !== "true") {
            setShowDisclaimer(true);
        }
    }, []);

    const acceptDisclaimer = () => {
        localStorage.setItem("disclaimerAccepted", "true");
        setShowDisclaimer(false);
    };

    const showDisclaimerDialog = () => {
        setShowDisclaimer(true);
    };

    const hideDisclaimerDialog = () => {
        setShowDisclaimer(false);
    };

    const value = {
        showDisclaimer,
        acceptDisclaimer,
        showDisclaimerDialog,
        hideDisclaimerDialog,
    };

    return <DisclaimerContext.Provider value={value}>{children}</DisclaimerContext.Provider>;
};
